import { getOmniLogger } from 'omni-package-react-logging';
import Axios from 'axios';
import { getSiteCoreApiUrl } from './getSiteCoreApiUrl';
import { filterInstabilityMessages } from './filterInstabilityMessages';
import { getLanguage } from '../utils/getLanguage';
import { InstabilityMessageModel } from '../interfaces/InstabilityMessageModel';

export async function getInstabilityMessages(lineOfBusiness: string = null): Promise<string[]> {
  const logger = getOmniLogger(process.env.REACT_APP_LOGGING_APPLICATION_NAME);
  const lang = getLanguage();
  let url = `${getSiteCoreApiUrl()}/instabilityMessages?sc_lang=${lang}`;
  if (lineOfBusiness) url = `${url}&lobCode=${lineOfBusiness}`;
  try {
    const response = await Axios.get<InstabilityMessageModel[]>(url);
    return filterInstabilityMessages((response).data);
  } catch (error) {
    logger.error(`InstabilityMessages component query to SiteCore failed with reason: ${JSON.stringify(error)}.`);
    return null;
  }
}
